"use client";

import * as React from "react";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
const projects = [{
  id: 1,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/stittsville_lawn_transformation_before_after.png",
  url: "Stittsville Residential Sodding"
}, {
  id: 2,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/kanata_garden_bed_restoration.png",
  url: "Kanata Garden Bed Cleanup"
}, {
  id: 3,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_west_landscape_overhaul.png",
  url: "Ottawa West Seasonal Revival"
}];
export default function BeforeAfterGallery() {
  return <section data-section-id="223247" id="before-after-gallery" className="w-full bg-background text-foreground py-24">
      <div className="container mx-auto max-w-7xl px-4 md:px-8">
        <div className="mb-16 text-center">
          <h2 className="font-default text-foreground mb-4 text-3xl font-bold md:text-4xl">
            Our Stittsville Transformations
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg font-default">
            Witness the dramatic results of our professional lawn care and landscaping services across the local community.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {projects.map((project, i) => <div key={project.id} data-index={i} className="group flex flex-col gap-5">
              {}
              <div className="relative aspect-[4/3] w-full overflow-hidden rounded-lg shadow-md">
                <img src={project.image} alt={`Professional lawn care transformation in Stittsville ${i + 1}`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                
                {}
                <div className="bg-secondary text-secondary-foreground absolute top-5 -right-10 w-40 rotate-45 py-1 text-center text-[10px] font-bold tracking-wider shadow-sm">
                  RECENT WORK
                </div>
              </div>

              {}
              <div className="border-border bg-card group-hover:border-primary/50 flex w-full items-center rounded-lg border p-1 shadow-sm transition-colors duration-300">
                <Input defaultValue={project.url} readOnly className="text-muted-foreground h-10 flex-1 border-0 bg-transparent px-4 text-sm font-default shadow-none focus-visible:ring-0" aria-label="Project Location" />
                <Button size="icon" className="bg-primary text-primary-foreground group-hover:bg-secondary group-hover:text-secondary-foreground size-10 shrink-0 rounded-md transition-all duration-300 group-hover:shadow-lg" aria-label="View details">
                  <Search className="size-4" />
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}